export enum PATH {
	HOME = "/",
	SPLASH = "/splash",
	LANDING = "/landing",
	PRODUCT_LIST = "/product-list",
	CART = "/cart",
	PAYMENT = "/payment",
	ORDER_CONFIRMATION = "/order-confirmation",
	INFO = "/info",
	ADMIN = "/admin",
	MAINTENANCE = "/maintenance",
	CASH_QR = "/cash-qr",
	// anchor - for code generator
}
